import { Caption, Rate } from 'fronton-react';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { Styles } from '../styles';
import { RatingFormPart, ScoreField } from './layout-blocks';
import { ReviewFormFieldError, TotalScoreStateProps } from '../types';

export const ReviewScoresFormPart: React.FC<
  TotalScoreStateProps & {
    breakpoint: Breakpoint;
    errors: ReviewFormFieldError[] | null;
  }
> = ({ totalScore, breakpoint, errors, setTotalScore }) => {
  const doSetTotalScore = React.useCallback(setTotalScore, [setTotalScore]);
  const totalScoreErrorCaption = errors?.filter((r) => r.fieldKey === 'rating')[0]?.message ?? null;

  return (
    <RatingFormPart>
      <ScoreField
        asColumn={breakpoint === 'mobile'}
        scoreControl={
          <Rate
            data-qa="rating-form-total-score_mf-pdp"
            id="rating"
            size="xl"
            rating={totalScore ?? undefined}
            onChange={doSetTotalScore}
            className={Styles.ratingScore}
          />
        }
        captionView={totalScoreErrorCaption ? <Caption error message={totalScoreErrorCaption} /> : undefined}
      />
    </RatingFormPart>
  );
};
